import script from "./TeamDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamDashboard.vue?vue&type=script&setup=true&lang=js"

import "./TeamDashboard.vue?vue&type=style&index=0&id=72a31766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72a31766"]])

export default __exports__